<div class="modal-header">
  <h4 class="modal-title h5" translate>Legal notice</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div [innerHTML]="imprintContent"></div>
</div>
<scitis-modal-footer
    [okButtonText]="closeButtonText"
    [showCancelButton]="false"
    (okButtonPressed)="onClose()">
</scitis-modal-footer>
